import React from 'react';
import { MenuItem, Select, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    height: '1rem',
    width: '3.0rem',
    fontSize: '0.75rem'
  },
}));

interface Props {
  value: number,
  onChange: (e: React.ChangeEvent<{
    name?: string | undefined;
    value: unknown;
  }>) => void,
  maxNum: number,
}

/** ゴルフバッグの個数選択のコンポーネント。 */
export const SelectGolfBag: React.FC<Props> = (props: Props) => {
  const classes = useStyles();
  /** ゴルフバッグの個数（0からタクシー台数に応じた最大数までの数値）の値の配列。 */
  const numbers = Array.from(Array(props.maxNum + 1).keys());

  return (
    <Select
      className={classes.root}
      SelectDisplayProps={{
        style: {
          padding: '10px'
        }
      }}
      onChange={props.onChange}
      value={props.value}
    >
      {
        numbers.map((n) => {
          return <MenuItem value={n} key={`golfbag_${n}`}>{n}</MenuItem>
        })
      }
    </Select>
  );
}

export default SelectGolfBag;
